<template>
  <main>
    <section class="content-wrapper">
      <ag-header title="Das neue Advogarant Kundencenter ist da!"/>
      <div class="content__body">
        <p class="content__text">
          Sehr geehrte(r) Advogarant NutzerIn,<br><br>
          Sie haben versucht die alte Kundenzone aufzurufen. Diese wurde jedoch
          durch das neue und bessere Advogarant Kundencenter ersetzt.
        </p>
        <p>
          Um sich im neuen Kundencenter einzuloggen brauchen Sie Ihre
          <strong>neuen Zugangsdaten</strong>, die Sie per E-Mail erhalten haben.
          <router-link :to="{name: 'login'}">Zum Login</router-link>
        </p>
        <p>
          Sollten Sie keine E-Mail erhalten haben, wenden Sie sich bitte an unseren Support
          entweder per E-Mail <a href="mailto:kunden@advogarant.de">kunden@advogarant.de</a> oder
          telefonisch unter <a href="tel:+49-221-820-12-70">0221 820 12 70</a>.
        </p>
        <p>
          Ihre Vorteile des neuen Kundencenters:
        </p>
        <ul class="content__list">
          <li class="content__list-item">
            Transparente Übersicht über Ihre gebuchten Leistungen
          </li>
          <li class="content__list-item">
            Möglichkeit, eigenständig Ihr Profil zu bearbeiten
          </li>
          <li class="content__list-item">
            Weiterführende Informationen zu jedem unserer Bausteine
          </li>
          <li class="content__list-item">
            Erleichterte Bedienbarkeit – <strong>sogar unterwegs mit Ihrem Smartphone!</strong>
          </li>
          <li class="content__list-item">
            Kontinuierliche Weiterentwicklung und viele neue Funktionen in der Zukunft
          </li>
        </ul>
        <p class="content__text">
          Wir begrüßen Sie herzlich im neuen Kundencenter!<br>

          Ihr Team von AdvoGarant
        </p>
        <router-link
          class="button-link"
          :to="{name: 'login'}"
        >
          Zum Login
        </router-link>
        <ag-info-box />
      </div>
    </section>
  </main>
</template>

<script>
import AgHeader from '@/components/shared/AgHeader.vue';
import AgInfoBox from '@/components/shared/AgInfoBox.vue';

export default {
  name: 'CustomerLandingpage',
  metaInfo: {
    title: 'Das neue Advogarant Kundencenter',
  },
  components: {
    AgHeader,
    AgInfoBox,
  },
};
</script>

<style lang="scss">
@include mq($mq-medium) {
  /* assuming a tablet/desktop is not able to make phone calls */
  a[href^="tel:"] {
    &:link,
    &:visited,
    &:focus,
    &:active,
    &:hover {
      cursor: text;
      color: $text-color;
      pointer-events: none;
    }
  }
}
</style>
